var map = {
	"./ICE_logo_black.png": "45c2",
	"./ICE_logo_black.svg": "cd51",
	"./Iceberg_Logo.png": "271d",
	"./LOGO Vinqlo novo.png": "5a9d",
	"./Logo_Gifi.jpeg": "adde",
	"./bento_nascimento.png": "0ab8",
	"./e-cost.png": "f187",
	"./live_logo.png": "bc46",
	"./logo_cm_valongo.svg": "41e5",
	"./morcode.png": "cdcc",
	"./vinqlo_logo.jpg": "1c6a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b2a";